<template>
  <div class="data-content-box">
    <dragPanel v-show="dataManageTreeVisible">
      <data-manage-tree
        ref="dataManageTree"
        :width="242"
        :data="treeData"
        :nodeClick="handleNodeClick"
        :hideDataManageTree="hideDataManageTree" />
    </dragPanel>
    <div
      v-if="!dataManageTreeVisible"
      class="icon-box">
      <icon-svg
        icon-class="ic-ico_an"
        class="icon"
        title="展开目录树"
        @click.native="openDataManageTree" />
    </div>
    <div class="data-content page-primary">
      <div
        v-if="loading"
        class="loading-box">
        <div
          v-loading="true"
          class="loading"></div>
      </div>
      <breadcrumb
        :breadcrumbList="breadcrumbList"
        :breadcrumbClick="breadcrumbClick" />
      <div class="operate-area">
        <div class="common-button-box">
          <div v-if="isButtonVisible('newMap')">
            <el-button
              type="primary"
              size="small"
              class="primary-btn gr9"
              @click="addNewMap"
              >新增地图</el-button
            >
          </div>
          <div v-if="isButtonVisible('newFolder')">
            <el-button
              size="small"
              class="normal-btn gr9"
              @click="addNode(1)"
              >新建文件夹</el-button
            >
          </div>
          <div
            v-if="isBatchButtonVisible('modelBatchOperate', '')"
            class="common-dropdown-box">
            <el-dropdown
              placement="bottom-start"
              @command="modelBatchOperate">
              <el-button
                size="small"
                class="normal-btn">
                批量操作 <i class="el-icon-arrow-down"></i>
              </el-button>
              <el-dropdown-menu
                slot="dropdown"
                class="dropdown-menu dropdown-primary"
                :append-to-body="false">
                <el-dropdown-item
                  v-if="isBatchButtonVisible('moveTo', 'modelBatchOperate')"
                  command="3"
                  >移动到</el-dropdown-item
                >
                <!-- <el-dropdown-item v-if="isBatchButtonVisible('copyTo', 'modelBatchOperate')" command="4"
                   command="4"
                  >复制到</el-dropdown-item
                  > -->
                <el-dropdown-item
                  v-if="isBatchButtonVisible('deleteNode', 'modelBatchOperate')"
                  command="5">
                  删除
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="isBatchButtonVisible('share', 'modelBatchOperate')"
                  command="6"
                  >分享</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div>
          <el-input
            class="search-input input-primary"
            size="small"
            v-model="keywords"
            placeholder="请输入文件名"
            clearable
            @clear="search"
            @keyup.enter.native="search">
            <i
              slot="suffix"
              class="el-input__icon el-icon-search icon"
              @click="search" />
          </el-input>
        </div>
      </div>
      <div
        v-if="!modelTableVisible"
        class="common-empty-box"
        key="emptyPage">
        <bj-empty
          :image="getNoDataImg()"
          class="empty-page">
          <template slot="description">
            <div
              :class="`${
                isMicroAppMode() ? 'description-box empty-text' : 'empty-text'
              }`">
              抱歉，没有找到相关内容
            </div>
          </template>
          <div class="common-button-box text-center-c btn-group-primary">
            <el-button
              v-if="isButtonVisible('newMap')"
              type="primary"
              size="small"
              class="primary-btn gr8"
              @click="addNewMap"
              >新增地图</el-button
            >
            <el-button
              v-if="isButtonVisible('newFolder')"
              size="small"
              class="normal-btn"
              @click="addNode(1)"
              >新建文件夹</el-button
            >
          </div>
        </bj-empty>
      </div>
      <div
        v-show="modelTableVisible"
        class="data-view-box">
        <model-table
          :operaWidth="200"
          ref="modelTable"
          v-show="modelTableVisible"
          schemeType="Wmts"
          :rootNodeId="rootNodeId"
          :nodeId="selectNodeData.nodeId"
          :name="keywords"
          :updateModelTableVisible="updateModelTableVisible"
          :refreshCatalogTree="refreshCatalogTree"
          :handleCellClick="handleCellClick"
          :reNameNode="reNameNode"
          :openMoveTreeDialog="openMoveTreeDialog"
          :editWmtsMapService="editWmtsMapService"
          :openShareDialog="openShareDialog" />
      </div>
    </div>
    <add-node-dialog
      :visible="nodeDialogVisible"
      :title="nodeDialogTitle"
      schemeType="Wmts"
      :nodeType="nodeType"
      :editMode="editMode"
      :nodeInfo="nodeInfo"
      :submitNode="submitNode"
      :closeDialog="closeNodeDialog" />
    <serviceNameDialog
      v-if="serviceNameDialogVisible"
      :visible="serviceNameDialogVisible"
      :serviceName="serviceName"
      :submitConfig="submitConfig"
      :closeDialog="closeServiceNameDialog" />
    <moveTreeDialogVue
      :visible="moveTreeDialogVisible"
      :data="moveTreeData"
      :nodeClick="moveTreeNodeClick"
      :submitMove="submitMove"
      :closeDialog="closeMoveTreeDialog" />
    <CreateWmtsMap
      :visible="wmtsVisible"
      :configWmts="configWmts"
      :cancelCreate="cancelCreate" />
    <EditWmtsMap
      :visible="editDialog"
      :mapInfo="mapInfo"
      :refreshTable="refreshTable"
      :closeDialog="closeEditDialog" />
    <shareDialog
      :visible="shareDialogVisible"
      resourceType="dataSet"
      :resourceList="dataSetsToShare"
      :closeDialog="closeShareDialog" />
    <VerifyMsgDialog />
  </div>
</template>

<script>
import dragPanel from '@/components/DragPanel.vue'
import dataManageTree from '@/components/module/dataManage/DataManageTree.vue'
import breadcrumb from '@/components/module/dataManage/Breadcrumb.vue'
import moveTreeDialogVue from '@/components/module/dataManage/MoveTreeDialog.vue'
import CreateWmtsMap from './wmts/components/CreateWmtsMap.vue'
import EditWmtsMap from './wmts/components/EditWmtsMap.vue'
import addNodeDialog from '@/components/module/dataManage/AddNodeDialog.vue'
import serviceNameDialog from '@/components/module/dataManage/MapServiceNameDialog.vue'
import modelTable from '@/components/module/dataManage/ModelTable.vue'
import shareDialog from '@/components/ShareDialog.vue'
import VerifyMsgDialog from '@/components/module/dataManage/VerifyMsgDialog.vue'

import { getParentNode, findNodeById } from '@/utils/generalMethods'

import { Store } from '@/utils/store'
import { wmtsButtons } from '@/utils/dictionary'
import { isMicroAppMode } from '@/microAdapt/utils'

import {
  getWmtsTreeService,
  addWmtsLevelNodes,
  modifyWmtsNodeName,
  moveWmtsNode,
  configWmtsByTemplate
} from '@/service/interface'

export default {
  data() {
    return {
      dataManageTreeVisible: true,
      rootNodeId: '',
      rootNodeData: {},
      treeData: [],
      selectNodeData: {},

      loading: true,
      modelTableVisible: false,

      keywords: '',
      breadcrumbList: [{ id: 'all', name: 'WMTS地图服务' }],

      nodeDialogVisible: false,
      nodeDialogTitle: '',
      nodeType: 0,
      nodeInfo: null,
      editMode: '',

      moveTreeDialogVisible: false,
      moveTreeData: [],
      moveNodeData: null,

      wmtsVisible: false,
      mapConfigInfo: null,
      serviceNameDialogVisible: false,
      serviceName: '',

      editDialog: false,
      mapInfo: null,

      shareDialogVisible: false,
      dataSetsToShare: []
    }
  },
  components: {
    dragPanel,
    dataManageTree,
    breadcrumb,
    moveTreeDialogVue,
    CreateWmtsMap,
    EditWmtsMap,
    addNodeDialog,
    serviceNameDialog,
    modelTable,
    shareDialog,
    VerifyMsgDialog
  },
  mounted() {
    this.initData().then(() => {
      let nodeId = sessionStorage.getItem('WmtsNodeId')
      if (nodeId) {
        let selectData = this.findNodeById(this.treeData, nodeId)
        let domRef = this.$refs.dataManageTree
        if (selectData && domRef) {
          let node = domRef.getNode(selectData.nodeId)
          this.handleNodeClick(selectData, node)
        }
        sessionStorage.removeItem('WmtsNodeId')
      } else {
        let domRef = this.$refs.dataManageTree
        if (domRef) {
          let node = domRef.getNode(this.rootNodeData.nodeId)
          this.handleNodeClick(this.rootNodeData, node)
        }
      }
    })

    this.$eventManage.on('refreshTable', this.refreshTable)
  },
  beforeDestroy() {
    this.$eventManage.off('refreshTable', this.refreshTable)
  },
  methods: {
    openDataManageTree() {
      this.dataManageTreeVisible = true
    },
    hideDataManageTree() {
      this.dataManageTreeVisible = false
    },
    initData() {
      return new Promise(resolve => {
        let projId = this.$route.params.projId
        getWmtsTreeService({ projId }).then(response => {
          if (response.isSuccess) {
            let result = response.data
            if (result) {
              this.rootNodeData = result
              this.rootNodeId = result.rootId
              this.treeData = [result]
              this.moveTreeData = [result]
              resolve()
            } else {
              this.$message.error('获取资源目录失败，请稍后再试')
              this.$router.push('../../../projectList')
            }
          } else {
            this.$message.error(response.errMsg)
            this.$router.push('../../../projectList')
          }
        })
      })
    },
    refreshCatalogTree() {
      return new Promise(resolve => {
        let projId = this.$route.params.projId
        getWmtsTreeService({ projId }).then(response => {
          if (response.isSuccess) {
            let result = response.data
            this.rootNodeData = result
            this.treeData = [result]
            this.moveTreeData = [result]
            this.$nextTick(() => {
              let nodeId = this.selectNodeData.nodeId
              let selectData = this.findNodeById([result], nodeId)
              let domRef = this.$refs.dataManageTree
              if (selectData && domRef) {
                this.selectNodeData = selectData
                domRef.setCurrentKey(selectData.nodeId)
              }
            })
            resolve()
          } else {
            this.$message.error(response.errMsg)
            this.$router.push('../../../projectList')
          }
        })
      })
    },
    refreshTable() {
      if (this.$refs.modelTable) {
        if (!this.selectNodeData.nodeId) return
        this.$refs.modelTable.uploadDataList().then(total => {
          this.updateModelTableVisible(total)
        })
      }
    },
    search() {
      sessionStorage.removeItem('pageInfo')
      this.$refs.modelTable.uploadDataList(1)
    },
    handleCellClick(row) {
      let node = this.$refs.dataManageTree.getNode(row.nodeId)
      this.handleNodeClick(row, node)
    },
    handleNodeClick(nodeData, node) {
      // console.log(nodeData, "节点数据");
      this.loading = true
      this.selectNodeData = nodeData
      this.breadcrumbList = this.getBreadCrumbList(node)

      this.keywords = ''
      this.$refs.dataManageTree.setCurrentKey(nodeData.nodeId)
      sessionStorage.setItem('WmtsNodeId', nodeData.nodeId)

      this.$nextTick(() => {
        this.$refs.modelTable.uploadDataList(1).then(total => {
          this.updateModelTableVisible(total)
          this.loading = false
        })
      })
    },
    getBreadCrumbList(node) {
      let breadcrumbList = []
      if (node) {
        let parentNodes = []
        this.getParentNode(node, parentNodes)
        parentNodes.reverse()
        parentNodes.forEach(item => {
          let nodeData = item.data
          if (nodeData.nodeType === 0) {
            breadcrumbList.push({
              id: nodeData.nodeId,
              name: 'WMTS地图服务'
            })
          } else {
            breadcrumbList.push({
              id: nodeData.nodeId,
              name: nodeData.nodeName
            })
          }
        })
      } else {
        breadcrumbList = [{ id: this.rootNodeId, name: 'WMTS地图服务' }]
      }
      return breadcrumbList
    },
    breadcrumbClick(data) {
      if (this.breadcrumbList.length === 1) return
      if (data.id === this.rootNodeId) {
        this.selectNodeData = this.rootNodeData
        this.$refs.dataManageTree.setCurrentKey(null)
        this.handleNodeClick(this.rootNodeData)
      } else {
        let selectData = this.findNodeById(this.treeData, data.id)
        let node = this.$refs.dataManageTree.getNode(selectData.nodeId)
        this.handleNodeClick(selectData, node)
      }
    },
    modelBatchOperate(command) {
      switch (command) {
        case '1':
          this.$refs.modelTable.batchDownloadFiles()
          break
        case '2':
          console.log('分享')
          break
        case '3':
          this.$refs.modelTable.batchMoveNode()
          break
        case '5':
          this.$refs.modelTable.batchDeleteNode()
          break
        case '6':
          this.$refs.modelTable.batchShare()
          break
        default:
          break
      }
    },
    addNode(nodeType) {
      let node = this.$refs.dataManageTree.getNode(this.selectNodeData.nodeId)
      if (node && node.level > window.maxLevel) {
        this.$message.warning(`最多只支持${window.maxLevel + 1}级`)
        return false
      }

      this.nodeDialogVisible = true
      this.nodeDialogTitle = '新建文件夹'
      this.nodeType = nodeType
      this.editMode = 'addNode'
    },
    reNameNode(nodeInfo) {
      let nodeType = nodeInfo.nodeType

      this.nodeDialogVisible = true
      this.nodeDialogTitle = nodeType === 1 ? '重命名文件夹' : '重命名模型组'
      this.nodeType = nodeType
      this.editMode = 'reNameNode'
      this.nodeInfo = nodeInfo
    },
    closeNodeDialog() {
      this.nodeDialogVisible = false
      this.nodeDialogTitle = ''
      this.nodeType = 0
      this.editMode = ''
      this.nodeInfo = null
    },
    submitNode(paramsInfo) {
      return new Promise(resolve => {
        if (this.editMode === 'addNode') {
          let params = {
            parentId: this.selectNodeData.nodeId,
            nodeNames: [paramsInfo.nodeName]
          }
          if (this.nodeType === 1) {
            addWmtsLevelNodes(params).then(response => {
              if (response.isSuccess) {
                let data = response.data[0]
                this.refreshCatalogTree().then(() => {
                  let selectData = this.findNodeById(this.treeData, data.nodeId)
                  if (selectData) {
                    let node = this.$refs.dataManageTree.getNode(
                      selectData.nodeId
                    )
                    this.handleNodeClick(selectData, node)
                  }
                })
                resolve(response)
              } else {
                resolve(response)
              }
            })
          }
        }

        let dataInfo = this.nodeInfo
        if (this.editMode === 'reNameNode') {
          let params = {
            nodeId: dataInfo.nodeId,
            nodeName: paramsInfo.nodeName
          }
          modifyWmtsNodeName(params).then(response => {
            if (response.isSuccess) {
              this.refreshCatalogTree()
              this.refreshTable()
              resolve(response)
            } else {
              resolve(response)
            }
          })
        }
      })
    },
    addNewMap() {
      this.wmtsVisible = true
    },
    configWmts(configInfo) {
      // let projId = this.$route.params.projId;
      // let nodeId = this.selectNodeData.id;
      // let params = {
      //   projctZoneId: projId,
      //   nodeId: nodeId,
      //   templateId: configInfo.templateId,
      //   enableCoverage: configInfo.enableCoverage,
      //   effectiveCoverageTop: configInfo.effectiveCoverageTop,
      //   effectiveCoverageDown: configInfo.effectiveCoverageDown,
      //   effectiveCoverageLeft: configInfo.effectiveCoverageLeft,
      //   effectiveCoverageRight: configInfo.effectiveCoverageRight,
      // };
      this.mapConfigInfo = configInfo
      this.wmtsVisible = false
      this.serviceName = configInfo.serviceName
      this.serviceNameDialogVisible = true
      // configWmtsByTemplate(params).then((res) => {
      //   if (res.status === 200) {
      //     this.queryFiles().then(() => {
      //       this.wmtsVisible = false;
      //       this.refreshCatalogTree();
      //     });
      //   }
      // });
    },
    cancelCreate() {
      this.wmtsVisible = false
      this.mapConfigInfo = null
    },
    submitConfig(configInfo) {
      return new Promise(resolve => {
        let projId = this.$route.params.projId
        let nodeId = this.selectNodeData.nodeId
        let params = {
          projId,
          nodeId,
          serviceName: configInfo.serviceName,
          templateId: this.mapConfigInfo.templateId,
          enableCoverage: this.mapConfigInfo.enableCoverage,
          effectiveCoverageTop: this.mapConfigInfo.effectiveCoverageTop,
          effectiveCoverageDown: this.mapConfigInfo.effectiveCoverageDown,
          effectiveCoverageLeft: this.mapConfigInfo.effectiveCoverageLeft,
          effectiveCoverageRight: this.mapConfigInfo.effectiveCoverageRight
        }
        configWmtsByTemplate(params).then(response => {
          if (response.isSuccess) {
            this.serviceNameDialogVisible = false
            this.serviceName = ''
            this.mapConfigInfo = null
            this.refreshCatalogTree()
            this.refreshTable()
            resolve(response)
          } else {
            resolve(response)
          }
        })
      })
    },
    closeServiceNameDialog() {
      this.mapConfigInfo = null
      this.serviceNameDialogVisible = false
      this.serviceName = ''
    },
    editWmtsMapService(mapInfo) {
      this.mapInfo = mapInfo
      this.editDialog = true
    },
    closeEditDialog() {
      this.editDialog = false
      this.mapInfo = null
    },
    openMoveTreeDialog(datas) {
      this.nodesToMove = datas
      this.moveTreeDialogVisible = true
    },
    moveTreeNodeClick(data, node) {
      this.moveNodeData = null

      if (data.nodeId === this.selectNodeData.nodeId) {
        this.$message.error('数据已在当前目录中，请选择其他目录！')
        return
      }

      let moveDataIds = this.nodesToMove.map(el => el.nodeId)
      if (moveDataIds.includes(data.nodeId)) {
        this.$message.error('不能移动到自身目录之下，请选择其他目录！')
        return
      }
      let nodesToMoveNodeType = this.nodesToMove.map(el => el.nodeType)[0]
      if (nodesToMoveNodeType === 1 && node.level > window.maxLevel) {
        this.$message.error(`文件夹最多支持${window.maxLevel + 1}级，请选择其他目录！`)
        return
      }

      let parentNodes = []
      this.getParentNode(node, parentNodes)
      let parentNodeIds = parentNodes.map(el => el.data.nodeId)
      parentNodeIds.forEach(item => {
        if (moveDataIds.includes(item)) {
          this.$message.error('不能移动到子目录之下，请选择其他目录！')
          return
        }
      })

      this.moveNodeData = data
    },
    submitMove() {
      if (!this.moveNodeData) {
        this.$message.error('请选择有效的目标目录！')
        return
      }

      let params = {
        targetNodeId: this.moveNodeData.nodeId,
        nodeIds: this.nodesToMove.map(el => el.nodeId)
      }
      moveWmtsNode(params).then(response => {
        if (response.isSuccess) {
          this.refreshCatalogTree()
          this.refreshTable()

          this.$message.success('移动成功!')
          this.moveNodeData = null
          this.nodesToMove = []
          this.moveTreeDialogVisible = false
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    closeMoveTreeDialog() {
      this.moveNodeData = null
      this.nodesToMove = []
      this.moveTreeDialogVisible = false
    },
    openShareDialog(dataSetsToShare) {
      this.dataSetsToShare = dataSetsToShare
      this.shareDialogVisible = true
    },
    closeShareDialog() {
      this.dataSetsToShare = []
      this.shareDialogVisible = false
    },
    updateModelTableVisible(total) {
      let visible = false
      if (total) {
        visible = true
      }
      this.modelTableVisible = visible
    },
    isBatchButtonVisible(buttonName, parentButtonName) {
      let visible = false
      if (Object.keys(this.selectNodeData).length) {
        if (parentButtonName) {
          let childrens = wmtsButtons.find(
            el => el.name === parentButtonName
          ).children
          let find = childrens.find(el => el.name === buttonName)
          visible = this.isChecked(find.permissionCode)
        } else {
          let childrens = wmtsButtons.find(
            el => el.name === buttonName
          ).children
          visible = childrens.some(el => this.isChecked(el.permissionCode))
        }

        if (visible) {
          visible = this.selectNodeData.isAuthorized
        }
      }
      return visible
    },
    isButtonVisible(buttonName) {
      let visible = false
      if (Object.keys(this.selectNodeData).length) {
        let find = wmtsButtons.find(el => el.name === buttonName)
        visible = this.isChecked(find.permissionCode)
      }
      return visible
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    getNoDataImg() {
      if (isMicroAppMode()) {
        return require('@/assets/img/no-data-nebula.png')
      } else {
        return require('@/assets/img/no-data.png')
      }
    },
    getParentNode,
    findNodeById,
    isMicroAppMode
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
@import '@/assets/css/pageStyle.less';

.data-content-box {
  .data-content {
    margin-left: 16px;
    padding: 16px;
    margin-bottom: 0;
    overflow: hidden;
    .operate-area {
      width: 100%;
    }

    .data-view-box {
      height: calc(100% - 79px);

      :deep(.common-table-box) {
        height: calc(100% - 65px) !important;
      }
    }
  }
}

.empty-box {
  margin: 200px 0px;

  .el-empty {
    .el-empty__bottom {
      margin-top: 0px;
    }
  }
}
</style>
